var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77018 12.7917L13.666 6.89582L12.7077 5.95832L7.77018 10.8958L5.27018 8.39582L4.33268 9.33332L7.77018 12.7917ZM8.99935 17.3333C7.86046 17.3333 6.78407 17.1146 5.77018 16.6771C4.75629 16.2396 3.87088 15.6423 3.11393 14.8854C2.35699 14.1285 1.75977 13.243 1.32227 12.2292C0.884766 11.2153 0.666016 10.1389 0.666016 8.99999C0.666016 7.84721 0.884766 6.76388 1.32227 5.74999C1.75977 4.7361 2.35699 3.85416 3.11393 3.10416C3.87088 2.35416 4.75629 1.76041 5.77018 1.32291C6.78407 0.885406 7.86046 0.666656 8.99935 0.666656C10.1521 0.666656 11.2355 0.885406 12.2493 1.32291C13.2632 1.76041 14.1452 2.35416 14.8952 3.10416C15.6452 3.85416 16.2389 4.7361 16.6764 5.74999C17.1139 6.76388 17.3327 7.84721 17.3327 8.99999C17.3327 10.1389 17.1139 11.2153 16.6764 12.2292C16.2389 13.243 15.6452 14.1285 14.8952 14.8854C14.1452 15.6423 13.2632 16.2396 12.2493 16.6771C11.2355 17.1146 10.1521 17.3333 8.99935 17.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.de2c7e9e1f36613e04d65d048a297d43.svg";
export { ForwardRef as ReactComponent };